// extracted by mini-css-extract-plugin
export var checkbox = "styles-module--checkbox--1BKtR";
export var error = "styles-module--error--d7fS6";
export var checkbox_icon = "styles-module--checkbox_icon--3tvlR";
export var checkbox_cont = "styles-module--checkbox_cont--11ESZ";
export var checkbox_elem = "styles-module--checkbox_elem--6C0Vr";
export var checkbox_label = "styles-module--checkbox_label--3Jyzf";
export var checkbox_error = "styles-module--checkbox_error--3CRSA";